import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import CookiePrivacyPolicyPopup from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import * as React from "react";

/* Poolcorp Custom Code */
import isWebsiteAccessedByMobileApp from "@store/utilities/isWebsiteAccessedByMobileApp";
import { css } from "styled-components";
/* Poolcorp Custom Code */

export interface FooterStyles {
    page?: MobiusPageProps;
    // Poolcorp Custom Code
    mobileAppHiddenPage?: MobiusPageProps;
}

export const footerStyles: FooterStyles = {
    mobileAppHiddenPage: {
        css: css`
            display: none;
        `,
    },
};
const styles = footerStyles;

const Footer = ({ id }: PageProps) => {
    /* Poolcorp Custom Code */
    const isAppMobileView = isWebsiteAccessedByMobileApp();

    if (isAppMobileView) {
        return null;
    }
    /* Poolcorp Custom Code */

    return ( // Poolcorp Custom Code
        <Page 
            as="footer" 
            isFooter={true} 
            {...(isAppMobileView ? styles.mobileAppHiddenPage : styles.page)} // Poolcorp Custom Code
        >
            <Zone contentId={id} zoneName="Content" />
            <CookiePrivacyPolicyPopup />
        </Page>
    );
}

const pageModule: PageModule = {
    component: Footer,
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "Footer" instead of this constant.
 */
export const FooterContext = "Footer";
